import { cn } from '@/utils/cn';
import { InputHTMLAttributes, ReactNode } from 'react';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: ReactNode;
  checked: boolean;
  onChange: () => void;
  className?: string;
  error?: string | boolean;
}

export const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  className,
  error,
  ...props
}: CheckboxProps) => {
  return (
    <div className={cn('flex flex-col items-start', className)}>
      <div className="flex items-center">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className={cn(
            'size-4 rounded border-gray-300 text-sky-600 focus:ring-sky-500',
            error
              ? 'border-red-500 focus:border-red-500 focus:ring-red-200'
              : '',
          )}
          {...props}
        />
        {label && (
          <label
            htmlFor={id}
            className="ml-2 block cursor-pointer text-sm font-medium text-gray-700"
          >
            {label}
          </label>
        )}
      </div>
      {typeof error === 'string' && (
        <span className="mt-1 text-xs text-danger md:text-sm">{error}</span>
      )}
    </div>
  );
};
